<template>
    <div>
        <div class="All">
            <div class="image">
                <img :src="sku.imgUrl" style="width:100%">
            </div>
            <div class="skuInfo">
                <p style="font-weight: 800;font-size: 20px">{{sku.skuName}}</p>
                <p style="margin-top:10px;font-weight: 800;font-size: 25px;color: red">￥{{sku.skuPrice}}.00</p>
                <p style="margin-top: 10px;color: #999999">{{sku.skuSharerDescribe}}</p>
                <p style="margin-top: 5px;color: #999999">{{sku.specification}}/{{sku.auxiliaryDictName}}</p>
                <p style="margin-top: 5px">店铺名称：{{sku.storeName}}</p>
            </div>
            <div class="skuExplain">
                <div class="title">
                    <span style="margin-left: 10px">商品详情</span>
                </div>
                <div style="font-size: 15px;line-height: 30px;padding:0 19px 20px" class="desc-wrapper" v-html="sku.skuExplain"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                sku: {},
                skuId:''
            }
        },

        created() {
            this.skuId = this.$route.params.skuId
        },

        mounted(){
            this.getSkuInfo();
        },
        methods: {
            // 获取商品信息
            async getSkuInfo(){
                let data ={
                    id : this.skuId
                }
                let res = await this.$get('/api/getSkuInfo',data);
                if(res.code==='200'){
                    this.sku = res.Sku
                }else{

                }
            },
        }
    }

</script>

<style >
    .All{
        width: 90%;
        margin: 0 auto;
        margin-top: 20px;
    }
    .image {
        width: 100%;
    }
    .skuInfo{
        margin-top: 10px;
        font-size: 18px;
    }
    .skuExplain{
        margin-top: 20px;
        line-height: 40px;
        border:1px #e4e4e4 solid;
    }
    .title{
        background-color: #f9f9f9;
        border-bottom:1px #e4e4e4 solid;
        height: 40px;
        font-size: 15px;
    }
    .desc-wrapper img{
        width: 100%;
    }
</style>